const SIDE_PATCH_FOCUS_ROTATION = [-3.12, -1.33, 0];
const FRONT_PATCH_FOCUS_ROTATION = [-2.68, 0, 0];

export const PATCH_COMPONENT_IDS = ["custom-patch-front", "custom-patches-side"];

export function getPatchFocusPreset(itemId) {
  const presets = {
    "customText-front-patch": { modelScale: 1.8, modelRotation: FRONT_PATCH_FOCUS_ROTATION },
    "customImage-front-patch": { modelScale: 1.8, modelRotation: FRONT_PATCH_FOCUS_ROTATION },
    "customText-side-patches": { modelScale: 1.8, modelRotation: SIDE_PATCH_FOCUS_ROTATION },
  };
  return presets[itemId] ?? null;
}

export function getShortestPathRotation(targetRotationArray, rotationRoot) {
  const axes = ["x", "y", "z"];
  return targetRotationArray.map((targetRadians, index) => {
    const exactRotation = rotationRoot.rotation[axes[index]];
    const fullTurns = Math.round(exactRotation / (Math.PI * 2));

    const rotationsToTest = [
      (fullTurns - 1) * (Math.PI * 2) + targetRadians,
      fullTurns * (Math.PI * 2) + targetRadians,
      (fullTurns + 1) * (Math.PI * 2) + targetRadians,
    ];

    let closestRotation = rotationsToTest[1];
    let smallestDelta = Infinity;
    rotationsToTest.forEach((rotation) => {
      const delta = Math.abs(exactRotation - rotation);
      if (delta < smallestDelta) {
        smallestDelta = delta;
        closestRotation = rotation;
      }
    });

    return closestRotation;
  });
}
